/**
 * @generated SignedSource<<ae03de70928d08fd83765531e5324846>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueTable_nativeIssueTable$data = {
  readonly edges: ReadonlyArray<{
    readonly __typename: "JiraIssueEdge";
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"tableBody_nativeIssueTable">;
  readonly " $fragmentType": "issueTable_nativeIssueTable";
};
export type issueTable_nativeIssueTable$key = {
  readonly " $data"?: issueTable_nativeIssueTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueTable_nativeIssueTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "issueTable_nativeIssueTable",
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isInlineEditingEnabled",
          "variableName": "isInlineEditingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "tableBody_nativeIssueTable"
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "9f271a5e81f5f6fa93322fb8bc1ec67f";

export default node;
